var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgScheduledNotifications = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 15C8.79086 15 7 13.2091 7 11C7 8.79086 8.79086 7 11 7C13.2091 7 15 8.79086 15 11C15 13.2091 13.2091 15 11 15ZM11.795 12.5L10.5 11.205V9H11.5V10.795L12.5 11.795L11.795 12.5ZM8 11C8 9.34315 9.34315 8 11 8C12.6569 8 14 9.34315 14 11C14 12.6569 12.6569 14 11 14C9.34315 14 8 12.6569 8 11Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.122 6C11.7152 3.8772 10.0284 2.26042 7.82719 2V1H6.85188V2C4.4136 2.3 2.46297 4.4 2.46297 7V9.3L1.09754 10.6C1.00001 10.7 0.999911 10.8127 1.00001 11V12.5C1.00001 12.8 1.19507 13 1.39013 13H4.90125H6V12H1.97531V11.2L3.24322 9.8C3.258 9.78339 3.27254 9.76745 3.2866 9.75204L3.28665 9.75198C3.3711 9.65938 3.43828 9.58571 3.43828 9.5V7C3.43828 4.8 5.19384 3 7.33953 3C9.14877 3 10.6806 4.27976 11.1165 6H12.122Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgScheduledNotifications);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scheduled-notifications.7ce9b506a5b9aa4bfbf9f2040f42c503.svg";